import { render, staticRenderFns } from "./OutagesList.vue?vue&type=template&id=3a91ddc9&scoped=true"
import script from "./OutagesList.vue?vue&type=script&lang=js"
export * from "./OutagesList.vue?vue&type=script&lang=js"
import style0 from "./OutagesList.vue?vue&type=style&index=0&id=3a91ddc9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a91ddc9",
  null
  
)

export default component.exports